import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiGrid } from "react-icons/fi";
import moment from "moment";

export default function Header({ symbol, updateSymbol }) {
  const navigate = useNavigate();
  const [openType, setOpenType] = useState(false);
  const dropdownRef = useRef(null);

  const watchlistSymbol =
    JSON.parse(localStorage.getItem("watchlistSymbol")) || [];

  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenType(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSymbolSelect = (opt) => {
    window.symboldata = opt;
    localStorage.setItem("symboldata", JSON.stringify(opt));
    setOpenType(false);
    updateSymbol(opt);
  };

  return (
    <div className="relative flex items-center justify-between bg-[var(--background)] px-4 py-3">
      {/* Back Button */}
      <div className="flex-1">
        <button
          onClick={() => navigate(-1)}
          className="w-8 h-8  backdrop-[var(--background)] bg-[var(--background)] flex items-center justify-center 
             transition-transform duration-300 ease-in-out 
             hover:scale-105 active:scale-110"
        >
          <FiArrowLeft className="text-[var(--text)] text-[25px]" />
        </button>
      </div>

      {/* Symbol Info */}
      <div className="text-center flex-1">
        <h2 className="text-[15px] font-bold text-[var(--text)]">
          {symbol.symbol_display || symbol.symbol}
        </h2>
        <p className="text-xs font-semibold text-[var(--text)]">
          {symbol.type === "nse_cash"
            ? "EQUITY"
            : moment(symbol.expiry_date).format("DD-MMM")}
        </p>
      </div>

      {/* Symbol Selector Button */}
      <div className="flex-1 flex justify-end relative" ref={dropdownRef}>
        <button
          onClick={() => setOpenType((prev) => !prev)}
          className="w-8 h-8 backdrop-[var(--background)] bg-[var(--background)] flex items-center justify-center 
             transition-transform duration-300 ease-in-out 
             hover:scale-105 active:scale-110"
        >
          <FiGrid className="text-[var(--text)] text-[25px]" />
        </button>

        {/* Dropdown */}
        {openType && (
          <div className="absolute top-12 right-0 w-56 bg-[var(--background)] border-2 border-[var(--hover)] rounded-xl shadow-lg z-20 overflow-hidden">
            {watchlistSymbol.length === 0 ? (
              <div className="px-3 py-3 text-sm text-[var(--text)] text-center">
                No symbols in watchlist
              </div>
            ) : (
              <div className="max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-[var(--text)] scrollbar-track-gray-100">
                {watchlistSymbol.map((opt, i) => (
                  <div
                    key={i}
                    onClick={() => handleSymbolSelect(opt)}
                    className={`px-4 py-2 text-sm cursor-pointer transition ${symbol.symbol_display === opt.symbol_display
                      ? "bg-[var(--background)] text-[var(--text)] font-semibold"
                      : "text-[var(--text)]"
                      }`}
                  >
                    {opt.symbol_display}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
